// extracted by mini-css-extract-plugin
module.exports = {"container":"Benefit_container__Hj_v7","title":"Benefit_title__Tahmi"};